export default __webpack_public_path__ + "static/media/feedbacks-bg-sm.a121035e.png";